import { FC } from 'react';
import { AllieLabel } from '../../../components';
import { StyledFilterBarDesktopContainer } from './FilterBar.styles';
import { FilterBarProps } from './FilterBar';
import { getDisplayText } from './utils';
import { SelectFilter, SearchableFilter } from './components';

const namespace = 'filter-bar-desktop';

export const AllieFilterBarDesktop: FC<FilterBarProps> = ({
  filters,
  labelAll,
  labelFilterBy,
  className,
  style,
  fullWidth,
}) => {
  return (
    <StyledFilterBarDesktopContainer style={style} fullWidth={fullWidth}>
      {labelFilterBy && <AllieLabel className={`${namespace}__label`}>{labelFilterBy}</AllieLabel>}
      <div className={`${namespace}__container-item`}>
        {filters.map(
          (filter) => {
            const {
              getOptions,
              component,
              selected,
              type = 'select',
              filterLabelAll,
            } = filter;
            
            const options = getOptions?.(labelAll);
            const displayText = getDisplayText(options || [], selected, filterLabelAll || labelAll);

            return (
              component || (
                type === 'select' ? (
                  <SelectFilter
                    key={`${filter.label}-select`}
                    filter={filter}
                    labelAll={labelAll}
                    className={className}
                    displayText={displayText}
                    options={options}
                    namespace={namespace}
                  />
                ) : (
                  <SearchableFilter
                    key={`${filter.label}-searchable`}
                    filter={filter}
                    labelAll={labelAll}
                    options={options}
                    namespace={namespace}
                  />
                )
              )
            );
          }
        )}
      </div>
    </StyledFilterBarDesktopContainer>
  );
};
